import { getToken, handleResponse, nextJsonApi } from '@/API/core';

const rolePermissions = {
  getPermissionsBasedOnRoleId: async (roleId: string) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get(`/role-permissions/${roleId}/role`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  updateRolePermissions: async (roleId: string, permissions: string[]) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.put(
        `/role-permissions/${roleId}/update`,
        {
          permissions: permissions,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default rolePermissions;
